export type CaptureGapLike = {
  startMs: number;
  endMs: number;
  reason: string;
};

export function coalesceCaptureGap<T extends CaptureGapLike>(
  gaps: readonly T[],
  gap: T,
  toleranceMs = 1_000
): { gaps: T[]; gap: T; merged: boolean } {
  const previous = gaps.at(-1);
  if (
    !previous ||
    previous.reason !== gap.reason ||
    gap.startMs > previous.endMs + toleranceMs
  ) {
    return { gaps: [...gaps, gap], gap, merged: false };
  }

  const mergedGap = {
    ...previous,
    startMs: Math.min(previous.startMs, gap.startMs),
    endMs: Math.max(previous.endMs, gap.endMs)
  } as T;
  return {
    gaps: [...gaps.slice(0, -1), mergedGap],
    gap: mergedGap,
    merged: true
  };
}
